import ModalTemplate, {modalPageDecorator} from "./ModalTemplate";
import { connect } from "redux-vue";
import * as moduleActions from "../actions/module";
import classNames from "classnames";
import moment from "moment";

const TranscriptModal = modalPageDecorator({
  props: ["user", "modules", "setModule"],

  watch: {
    /**
     *
     * @param nextVal
     * @param val
     */
    modules(nextVal, val) {
      if (val.fetch && nextVal.fetchSuccess) {
        const module = this.modules.collection.find(i => i.id == this.$route.params.id);
        if (module) {
          this.setModule(module);
        }
      }
    },

    /**
     *
     * @param nextVal
     * @param val
     */
    module(nextVal, val) {
      if (val.enroll && nextVal.enrollSuccess) {
        this.dismiss();
      }
    }
  },

  methods: {
    /**
     *
     * @param event
     */
    onPressModule (module) {
      return (e) => {
        e.preventDefault();
        this.setModule(module);
        this.$router.push({name: 'CoursePage', params: {id: module.id}});
      }
    },
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const completedCollection = this.modules.collection.filter(i => i.enrolled && i.completed);
    return (
      <ModalTemplate>
        <div class="m-2 lg:my-12">
    <div class="bg-white container md:max-w-5xl mx-auto rounded shadow-lg relative z-50 overflow-hidden">
      <div class="p-5 pb-10">
        <div onClick={this.dismiss} class="cursor-pointer z-50 text-right">
          <i class="mdi mdi-close text-3xl lg:text-4xl leading-none"></i>
        </div>
        <div class="container px-3 lg:px-5">
            <div class="flex align-middle">
                <div><img src={'/img/who-logo-'+this.$i18n.locale+'-blue.png'} alt="WHO regional office for Africa" class="h-12 lg:h-16"/></div>
                <div><h1 class="text-sm lg:text-xl font-bold ml-6 text-blue-500 whitespace-no-wrap">
                {this.$t('nav.h1')}
                </h1></div>
                
            </div>
        </div>
        <div class="bg-white lg:pb-3 py-2 px-3 lg:px-5">
            <div class="flex mb-5 justify-between">
                <div class="flex flex-col">
                <h3 class="text-3xl">
                {this.$t('courses_page.course_results')}
                </h3>
                <p>{this.$t('courses_page.for')} {this.user.model.name}</p>
                </div>
                <div>
               </div>
            </div>  
            
            <div class="flex bg-gray-800 text-white">
              <p class="font-bold text-sm w-5/12 border-r border-gray-200 py-2 px-3 lg:px-5">{this.$t('courses_page.course')}</p>
              <p class="font-bold text-sm w-3/12 hidden lg:block border-r border-gray-200 py-2 px-3 lg:px-5">{this.$t('courses_page.date_completed')}</p>
              <p class="font-bold text-sm w-4/12 hidden lg:block py-2 px-3 lg:px-5">{this.$t('courses_page.results')}</p>
            </div>
            {completedCollection.map((i,n) => 
              
              <div class={classNames("relative border-b-2 text-sm" , { "bg-gray-300": n%2!=0 })}>
              <div class="flex flex-col lg:flex-row items-center">
                <div class="w-full lg:w-5/12 border-r border-gray-500 py-2 px-3 lg:px-5">
                    {i.name}
                </div>
                <div class="w-full lg:w-3/12 border-r border-gray-500 py-2 px-3 lg:px-5">
                {moment(i.last_activity_date).format("D MMM YYYY")}
                </div>
                <div class="w-full lg:w-4/12 py-2 px-3 lg:px-5">
            {Math.round(i.score)}% |
            <a href={"/courses/" + i.sequence} onClick={this.onPressModule(i)}
                  class="underline ml-1">
                  {this.$t('courses_page.retake_course')}
                </a>
                </div>
              </div>
            </div>

              )}
            
    
          </div>
      </div>
    </div>
  </div>
        </ModalTemplate>
    )
  }
});

function mapStateToProps(state) {
  return {
    user: state.user,
    modules: state.modules,
  };
}

function mapActionToProps(dispatch) {
  return {
    setModule: module => dispatch(moduleActions.setModule(module)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(TranscriptModal);